import {push} from 'react-router-redux'
import {put, takeEvery} from 'redux-saga/effects'

import * as actions from '../actionTypes'


const API_FAILURE_ACTIONS = [
  actions.LOGIN_FAILURE,
  actions.SESSION_INITIALIZE_FAILURE,
  actions.SESSION_RECALL_FAILURE,
  actions.DECISIONS_REQUESTED_FAILURE,
  actions.SESSION_REPORT_PDF_GENERATION_FAILURE,
  actions.CASE_ID_VALIDATION_FAILURE,
  actions.COUNSELING_SESSION_SAVE_FAILURE,
  actions.MATCHING_SESSION_IDS_REQUEST_FAILED,
  actions.SEND_EMAIL_FAIL
]

export function* errorRedirectSaga(action) {
  try {
    const {type, payload} = action
    if(API_FAILURE_ACTIONS.indexOf(type) > -1) {
      const {response: {status: statusCode}} = payload.error
      switch(statusCode) {
        case 401:
          yield put({type: actions.UNAUTHORIZED_REQUEST})
          if(type !== actions.LOGIN_FAILURE) { // If 401 wasn't received on login form
            yield put(push('/notice/401'))
          }
          break
        case 400:
          break
        default:
          yield put(push('/notice/500'))
      }
    }
  } catch(e) {}
}

export const errorRedirectSagas = [
  takeEvery('*', errorRedirectSaga)
]


// WEBPACK FOOTER //
// ./src/sagas/error-redirect.js